export default {
  austenite: 'Austenit',
  general: 'Właściwości ogólne',
};
